import { Component, OnInit, ViewChild, inject, ChangeDetectorRef } from '@angular/core';
import { Alert, AlertService, AlertType, TableComponent, TableConfig } from '@michelin/theme';
import { MatTableDataSource } from '@angular/material/table';
import { TranslationService } from '../../../../shared/translations/services/translation.service';
import { Store } from '@ngxs/store';
import { ReferenceInfo } from '../../models/reference-info.model';
import { ProductDataService } from '../../services/product-data.service';
import { TranslationState } from '../../../../shared/state/TranslationState';
import { ExportResponse } from '../../../../shared/services/export-to-excel.service';
import { finalize, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DealerState } from '../../../../shared/state/DealerState';
import { MatDialog } from '@angular/material/dialog';
import { ExportModalComponent, ExportModalData } from '../../../../shared/components/export-modal/export-modal.component';
import { ExportColumnDef } from '../../../../shared/models/export-column-def.model';

@Component({
  selector: 'app-product-axle',
  templateUrl: './product-axle.component.html',
  styleUrl: './product-axle.component.scss',
  standalone: false
})
export class ProductAxleComponent implements OnInit {
  @ViewChild(TableComponent, { static: true }) tableRef: TableComponent<ReferenceInfo>;

  public productDataService = inject(ProductDataService);
  public translationService = inject(TranslationService);
  public alertService = inject(AlertService);
  public cdr = inject(ChangeDetectorRef);
  public store = inject(Store);
  private dialog = inject(MatDialog);
  refInfos = new MatTableDataSource();
  isLoading = true;

  tableConfig: TableConfig<ReferenceInfo> = {
    columns: {}
  };
  dealerName = this.store.selectSnapshot(DealerState.currentDealer).name;
  columnNames: Record<string, string> = {};

  exportDataFetcher: () => Observable<ExportResponse> = () =>
    this.productDataService.getReferenceInformation('AXLE').pipe(
      map((response) => ({
        data: response.data.refInfos.map((item: ReferenceInfo) => ({
          referenceValue: item.referenceValue,
          description: item.description
        }))
      }))
    );

  openExportModal(): void {
    const columns: ExportColumnDef[] = Object.entries(this.columnNames).map(([key, label]) => ({ key, label, selected: true }));
    const data: ExportModalData = {
      columns,
      dataFetcher: this.exportDataFetcher,
      fileNamePrefix: this.dealerName + '-ProductAxle-export',
      maxExportRows: 10000
    };
    this.dialog.open(ExportModalComponent, { data, width: '480px' });
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.productDataService
      .getReferenceInformation('AXLE')
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        next: (response) => {
          this.refInfos = new MatTableDataSource(response.data.refInfos);
          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error('Error loading ref infos:', err);
          this.alertService.showAlert({
            type: AlertType.strong,
            content: this.translationService.translate('tryAgainText')
          } as Alert);
        }
      });

    this.store.select(TranslationState.currentLanguage).subscribe(() => {
      this.columnNames = {
        referenceValue: this.translationService.translate('codeText'),
        description: this.translationService.translate('descriptionText')
      };

      this.tableConfig.columns = {
        referenceValue: { cell: (row) => row.referenceValue, header: this.translationService.translate('codeText') },
        description: { cell: (row) => row.description, header: this.translationService.translate('descriptionText') }
      };
      this.cdr.markForCheck();
    });
  }
}
